import React from 'react';
import { Check, CheckCheck } from 'lucide-react';
import { format } from 'date-fns';

const MessageBubble = ({ message, isOwn }) => {
  const timeString = message.createdAt ? format(new Date(message.createdAt), 'HH:mm') : '';

  return (
    <div className={`flex ${isOwn ? 'justify-end' : 'justify-start'} mb-4`}>
      <div className={`max-w-[70%] rounded-2xl px-4 py-2 shadow-sm ${
        isOwn 
          ? 'bg-blue-600 text-white rounded-br-sm' 
          : 'bg-white text-gray-800 border border-gray-100 rounded-bl-sm'
      }`}>
        <p className="text-sm break-words whitespace-pre-wrap">{message.content}</p>
        <div className={`flex items-center justify-end mt-1 space-x-1 ${isOwn ? 'text-blue-100' : 'text-gray-400'}`}>
          <span className="text-[10px]">{timeString}</span>
          {isOwn && (
            <span className="ml-1">
              {message.status === 'sent' && <Check className="w-3 h-3" />}
              {message.status === 'delivered' && <CheckCheck className="w-3 h-3" />}
              {message.status === 'seen' && <CheckCheck className="w-3 h-3 text-blue-200" />}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default MessageBubble;
